import React from 'react';
import { getExtraWithDependenciesLabel } from '../labelGetters';
import FieldLabel from './FieldLabel';

export default function ExtraWithDependenciesDisplay({
  extraWithDeps,
  labels,
  isNew = false,
}) {
  const label = getExtraWithDependenciesLabel(extraWithDeps.id, labels);
  const displayName =
    label?.extraName ||
    extraWithDeps.extraName ||
    `Extra #${extraWithDeps.extraId || extraWithDeps.id}`;

  const requiredExperiences = label?.requiredExperiences || [];
  const suggestedExperiences = label?.suggestedExperiences || [];

  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  return (
    <div className={`p-2 bg-gray-50 rounded border ${borderClass}`}>
      <div className="flex items-center gap-2">
        <i className="fa-regular fa-puzzle-piece text-blue-500" />
        <span className="text-sm font-medium text-gray-700">{displayName}</span>
      </div>
      {(requiredExperiences.length > 0 || suggestedExperiences.length > 0) && (
        <div className="mt-1 ml-5 space-y-1">
          {requiredExperiences.length > 0 && (
            <div className="text-xs text-gray-500 flex items-center gap-1">
              <i className="fa-regular fa-asterisk text-red-400" />
              <span>
                <FieldLabel>Required</FieldLabel>
                {requiredExperiences.map((e) => e.name).join(', ')}
              </span>
            </div>
          )}
          {suggestedExperiences.length > 0 && (
            <div className="text-xs text-gray-500 flex items-center gap-1">
              <i className="fa-regular fa-lightbulb text-yellow-500" />
              <span>
                <FieldLabel>Suggested</FieldLabel>
                {suggestedExperiences.map((e) => e.name).join(', ')}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
